import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import { useSolicitacaoAssinatura } from '../../hooks/useSolicitacaoAssinatura';
import { getDocumentosParaAssinatura } from '../../utils/documentosAssinatura';
import AssinarDocumentosDialog from './AssinarDocumentosDialog';
import AssinaturaSessaoExpiradaDialog from './AssinaturaSessaoExpiradaDialog';
import GovbrNivelInsuficienteDialog from './GovbrNivelInsuficienteDialog';

type AssinaturaState = ReturnType<typeof useSolicitacaoAssinatura>;

type Props = {
  assinaturaState: AssinaturaState;
  onSignComplete: () => void;
};

export default function AssinarDocumentosDialogHost({
  assinaturaState,
  onSignComplete,
}: Props): JSX.Element {
  const {
    assinarDialog,
    assinaturaGate,
    getSignedDocumentIds,
    closeAssinaturaGate,
    reportNivelInsuficiente,
    closeAssinarDialog,
    markDocumentSigned,
  } = assinaturaState;

  return (
    <>
      {assinarDialog && (
        <AssinarDocumentosDialog
          open
          documentos={getDocumentosParaAssinatura(assinarDialog.request)}
          signedDocumentIds={getSignedDocumentIds(
            assinarDialog.request.identificador,
          )}
          initialIndex={assinarDialog.initialIndex}
          onClose={closeAssinarDialog}
          onDocumentSigned={documentoId =>
            markDocumentSigned(assinarDialog.request.identificador, documentoId)
          }
          onSignComplete={onSignComplete}
          onNivelInsuficiente={reportNivelInsuficiente}
        />
      )}

      <GovbrNivelInsuficienteDialog
        open={assinaturaGate?.type === 'nivel'}
        titulo={assinaturaGate?.type === 'nivel' ? assinaturaGate.titulo : ''}
        onClose={closeAssinaturaGate}
      />

      <AssinaturaSessaoExpiradaDialog
        open={assinaturaGate?.type === 'session'}
        message={
          assinaturaGate?.type === 'session'
            ? assinaturaGate.message
            : 'Sua sessão expirou. Faça login novamente para assinar.'
        }
        onClose={closeAssinaturaGate}
      />

      <Dialog
        open={assinaturaGate?.type === 'error'}
        onClose={closeAssinaturaGate}
        fullWidth
        maxWidth='sm'
      >
        <DialogTitle style={{ color: '#373F41' }}>Não foi possível continuar</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {assinaturaGate?.type === 'error' ? assinaturaGate.message : ''}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeAssinaturaGate} color='primary'>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
